// extracted by mini-css-extract-plugin
export default {"main_div":"ProjectDirectory_main_div__6gyxN","form_div":"ProjectDirectory_form_div__HnSSu"};